/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      if (jQuery(form).hasClass('product-type-byob') == false) {
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.changeItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeChangeItem.ajaxCart', form);
    },
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemChanged(line_item, form);
      }
      if (jQuery(form).hasClass('product-type-byob') == false) {
        $body.trigger('afterChangeItem.ajaxCart', [line_item, form]);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback,doneFreeGiftProduct,isBYOB) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart,doneFreeGiftProduct,isBYOB);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      //$body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

Handlebars.registerHelper('if_eq', function(a, b, opts) {
  if (a == b) {
    return opts.fn(this);
  } else {
    return opts.inverse(this);
  }
});

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, loadCartWithOutGetCart, loadWithOutCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $formContainerRemove, $addToCart, $removeToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $emptySelector, $triggerSelector, isBYOB;

  // Private functions
  var updateCountPrice, formOverride, formOverrideRemove, itemAddedCallback, itemRemovedCallback, itemErrorCallback, cartUpdateCallback, cartWithOutUpdateCallback, buildCart, cartCallback, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty, sizeCartDrawerFooter, submitAjaxCart;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector       : 'form[action^="/cart/add"]',
      formSelectorRemove : 'form[action^="/cart/change"]',
      cartContainer      : '#CartContainer',
      addToCartSelector  : 'input[type="submit"]',
      cartCountSelector  : null,
      cartCostSelector   : null,
      triggerSelector    : null,
      emptySelector      : null,
      moneyFormat        : '$',
      disableAjaxCart    : false,
      enableQtySelectors : true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $formContainerRemove     = $(settings.formSelectorRemove);
    $cartContainer     = $(settings.cartContainer);
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $removeToCart      = $formContainerRemove.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $emptySelector     = $(settings.emptySelector);
    $triggerSelector   = $(settings.triggerSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
      formOverrideRemove();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
    
    $( window ).resize(function() {
      sizeCartDrawerFooter();
      setTimeout(function() {
        sizeCartDrawerFooter();
      }, 1000)
    });
    $( window ).scroll(function() {
      sizeCartDrawerFooter();
      setTimeout(function() {
        sizeCartDrawerFooter();
      }, 1000)
    });
  };

  loadCart = function (doneFreeGiftProduct) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback, doneFreeGiftProduct);
  };

  loadCartWithOutGetCart = function (cart,doneFreeGiftProduct) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    $body.addClass('drawer--is-loading');
    cartUpdateCallback(cart,doneFreeGiftProduct);
    //ShopifyAPI.getCart(cartUpdateCallback, doneFreeGiftProduct);
  };

  loadWithOutCart = function () {
    ShopifyAPI.getCart(cartWithOutUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      var productPouches = 0,
          totalPouches = 0;
      var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
      var productSubscription = false;
      $.each(cart.items, function(index, cartItem) {
        productSubscription = false;
        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
              productSubscription = true;
            }
          });
        }
        if (Object.keys(productsSubscritionJson).length > 0) {
          if(productSubscription == true) {
            //console.log(price);
            for (var x in productsSubscritionJson) {
              //console.log(productsSubscritionJson[x]);
              if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                  productPouches = productsSubscritionJson[x]['pouches'];
                  break;
                }
              }
            }
          } else {
            if (productsSubscritionJson[cartItem.product_id] != undefined) {
              productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
            }
          }
        }
        totalPouches += productPouches*cartItem.quantity;
      });
      //$cartCountSelector.html(cart.item_count).removeClass('hidden-count');
      $cartCountSelector.html(totalPouches).removeClass('hidden-count');

      //if (cart.item_count === 0) {
      if (totalPouches === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.off('submit').on('submit', function(evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $addToCart.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      isBYOB = false;
      let productTitle = $(evt.target).closest('.product-top').find('.product__title').text();
      if ($(evt.target).hasClass('product-type-byob') == true) {
        //console.log('formContainer','product-type-byob');
        isBYOB = true;
        swal.close();
        //console.log('js-product-add-text',$(evt.target).find('.js-product-add-text').text());
        if ($(evt.target).find('.js-product-add-text').text() == 'Add Another') {
          mixpanel.track("BYOP Add Another", {"name": productTitle});
        } else {
          mixpanel.track("BYOP Add to Pack", {"name": productTitle});
        }
      } else {
        mixpanel.track("Premade Pack Add to Cart", {"name": productTitle});
      }

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);
    });
  };

  formOverrideRemove = function () {
    $formContainerRemove.off('submit').on('submit', function(evt) {
      evt.preventDefault();console.log(evt.target.querySelector('[name="id"]').value,$(evt.target).find('[name="id"]').val());

      // Add class to be styled if desired
      $removeToCart.removeClass('is-removed').addClass('is-removing');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      isBYOB = false;
      if ($(evt.target).hasClass('product-type-byob') == true) {
        //console.log('formContainerRemove','product-type-byob');
        isBYOB = true;
      	let productTitle = $(evt.target).closest('.product-top').find('.product__title').text();
        mixpanel.track("BYOP Remove", {"name": productTitle});
      }

      ShopifyAPI.changeItemFromForm(evt.target, itemRemovedCallback, itemErrorCallback);
    });
  };

  itemAddedCallback = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');

    if (isBYOB == true) {
      ShopifyAPI.getCart(cartUpdateCallback,false,isBYOB);
    }
    $body.trigger('afterChangeItem.ajaxCart');
  };

  itemRemovedCallback = function (product) {
    $addToCart.removeClass('is-removing').addClass('is-removed');

    if (isBYOB == true) {
      ShopifyAPI.getCart(cartUpdateCallback,false,isBYOB);
    }
    $body.trigger('afterChangeItem.ajaxCart');
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart, doneFreeGiftProduct, isBYOB) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    if(isBYOB === undefined) {
      isBYOB = false;
    }
    let doneRulesDiscount = false;
    /*if($('body').hasClass('template-gamification-a') == true) {
      if(typeof freeGiftProduct == 'function' && doneFreeGiftProduct != true) {
        var result = freeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        //console.log('cartUpdateCallback-result',result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      }
    } else if($('body').hasClass('template-gamification-b') == true) {*/
      if (isBYOB == true) {
        if(typeof dRRulesDiscount == 'function') {
          var cartSubscription = false;
          if (cart['attributes']['BYOK'] == null || cart['attributes']['BYOK'] == 'No') {
            $.ajax({
              type: 'POST',
              url: '/cart/update.js',
              data: 'attributes[BYOK]=Yes',
              async: false,
              dataType: 'json',
              success: function (newCart) {
                console.log('cartUpdateCallback-updateBYOP',newCart);
                cart = newCart;
              }
            });
          }
          if (cart['attributes']['Product Type'] == 'Subscription') {
            var cartSubscription = true;
          }
          var productPouches = 0;
          var total_price = 0;
          var totalPouches = 0;
          $.each(cart.items, function(index, cartItem) {
            var price = cartItem.price * cartItem.quantity;
            var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
            if (Object.keys(productsSubscritionJson).length > 0) {
              //console.log(price);
              if(cartSubscription == true) {
                for (let x in productsSubscritionJson) {
                  //console.log(productsSubscritionJson[x]);
                  if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                    //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                    if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                      productPouches = productsSubscritionJson[x]['pouches'];
                      price = productsSubscritionJson[x]["price"] * cartItem.quantity;
                      break;
                    }
                  }
                }
                //console.log(price);
              } else {
                if (productsSubscritionJson[cartItem.product_id] != undefined) {
                  productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
                }
              }
            }
            total_price += price;
            totalPouches += productPouches*cartItem.quantity;
          });
          dRRulesDiscount(totalPouches,cartSubscription);
          doneRulesDiscount = true;
        }
        // Update quantity and price
        updateCountPrice(cart);
    
        if(typeof Shopify.gamification.dRUpdateBYOB == 'function') {
          console.log('cartUpdateCallback','cart',cart)
          cart = Shopify.gamification.dRUpdateBYOB(cart, true, doneFreeGiftProduct, doneRulesDiscount);
        }
      }

      if (isBYOB == false || typeof dRRulesDiscount != 'function') {
        if(typeof dRFreeGiftProduct == 'function' && doneFreeGiftProduct != true) {
          var result = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
          //console.log('cartUpdateCallback-result',result);
          if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
            ShopifyAPI.getCart(cartUpdateCallback);
            return false;
          } else {
            cart = result.cart;
            doneFreeGiftProduct = true;
          }
        }
      }
    //}
    //if ((isBYOB == false && $('body').hasClass('template-gamification-b') == true) || $('body').hasClass('template-gamification-a') == true) {
    if (isBYOB == false) {
      // Update quantity and price
      updateCountPrice(cart);
      buildCart(cart,doneFreeGiftProduct,doneRulesDiscount);
    }
  };
  
  cartWithOutUpdateCallback = function (cart) {
    let doneFreeGiftProduct = false;
    let doneRulesDiscount = false;
    if(typeof dRRulesDiscount == 'function') {
      var cartSubscription = false;
      if (cart['attributes']['BYOK'] == null || cart['attributes']['BYOK'] == 'No') {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: 'attributes[BYOK]=Yes',
          async: false,
          dataType: 'json',
          success: function (newCart) {
            console.log('cartUpdateCallback-updateBYOP',newCart);
            cart = newCart;
          }
        });
      }
      if (cart['attributes']['Product Type'] == 'Subscription') {
        var cartSubscription = true;
      }
      var productPouches = 0;
      var total_price = 0;
      var totalPouches = 0;
      $.each(cart.items, function(index, cartItem) {
        var price = cartItem.price * cartItem.quantity;
        var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
        if (Object.keys(productsSubscritionJson).length > 0) {
          //console.log(price);
          if(cartSubscription == true) {
            for (x in productsSubscritionJson) {
              //console.log(productsSubscritionJson[x]);
              if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                  productPouches = productsSubscritionJson[x]['pouches'];
                  price = productsSubscritionJson[x]["price"] * cartItem.quantity;
                  break;
                }
              }
            }
            //console.log(price);
          } else {
            if (productsSubscritionJson[cartItem.product_id] != undefined) {
              productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
            }
          }
        }
        total_price += price;
        totalPouches += productPouches*cartItem.quantity;
      });
      dRRulesDiscount(totalPouches,cartSubscription);
      doneRulesDiscount = true;
    }
    // Update quantity and price
    updateCountPrice(cart);

    if(typeof Shopify.gamification.dRUpdateBYOB == 'function') {
      console.log('cartUpdateCallback','cart',cart)
      cart = Shopify.gamification.dRUpdateBYOB(cart, true, doneFreeGiftProduct, doneRulesDiscount);
    }

    if (typeof dRRulesDiscount != 'function') {
      if(typeof dRFreeGiftProduct == 'function' && doneFreeGiftProduct != true) {
        var result = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        //console.log('cartUpdateCallback-result',result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      }
    }
  };

  buildCart = function (cart,doneFreeGiftProduct,doneRulesDiscount) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    if(doneRulesDiscount === undefined) {
      doneRulesDiscount = false;
    }
    let buildYourKit = null;
    if ($cartContainer.find('.build-your-kit.wrapper').length) {
      buildYourKit = $cartContainer.find('.build-your-kit.wrapper').clone();
    }
    // Start with a fresh cart div
    $cartContainer.empty();

    //Update for Gamification AB - Correct Discount
    let changeABGamification = false;
    /*if ($('body').hasClass('template-gamification-a') == true) {
      if (cart['attributes']['AB Gamification'] != 'A') {
        data = "attributes[AB Gamification]=A";
        changeABGamification = true;
      }
    } else if ( $('body').hasClass('template-gamification-b') == true) {
      if (cart['attributes']['AB Gamification'] != 'B') {
        data = "attributes[AB Gamification]=B";
        changeABGamification = true;
      }
    }*/

    // Show empty cart
    if (cart.item_count === 0) {
      $(settings.emptySelector).show().addClass('subscription');
      $(settings.triggerSelector).removeClass('js-cart-full');
      //let newData = "attributes[Product Type]=One Time";
      let newData = "attributes[Product Type]=Subscription&attributes[mixpanel_id]=" + mixpanel.get_distinct_id();
      if (changeABGamification == true) {
        newData = newData + "&" + data;
      }

      //if (cart['attributes']['Product Type'] != 'One Time') {
      if (cart['attributes']['Product Type'] != 'Subscription') {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: newData,
          async: false,
          dataType: "json",
          success: function(t) {
            console.log('buildCart',t);
            cart = t;
          }
        });
      }
      cartCallback(cart);
      return;
    } else {
      $(settings.emptySelector).hide();
      $(settings.triggerSelector).addClass('js-cart-full');
      if (changeABGamification == true) {
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: data,
          async: false,
          dataType: "json",
          success: function(t) {
            console.log('buildCart-changeABGamification',t);
            cart = t;
          }
        });
      }
      
      if(cart['attributes'] == undefined || cart['attributes']['mixpanel_id'] == undefined) {
        let newData = "attributes[mixpanel_id]=" + mixpanel.get_distinct_id();
        $.ajax({
          type: "POST",
          url: "/cart/update.js",
          data: newData,
          async: false,
          dataType: "json",
          success: function(t) {
            console.log('buildCart',t);
            cart = t;
          }
        });
      }
    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {},
        source = $("#CartTemplate").html(),
        template = Handlebars.compile(source);
    
    var cartBYOK = false,
        cartBYOKDiscount = false,
        cartBYOKLinesDiscount = 0,
        cartBYOKLinesWithOutDiscount = 0,
        foundAllSubscription = true,
        cartLinesDiscount15 = 0,
        cartSubscription = false;
    
    if (cart.attributes != undefined) {
      if (cart.attributes["BYOK"] != undefined) {
        if (cart.attributes["BYOK"] == 'Yes') {
          cartBYOK = true;
        }
      }
      if ( cart.attributes["Discount code"] && cart.attributes["Discount code"] != 'False' ) {
        cartBYOKDiscount = cart.attributes["Discount code"];
      }
    }

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {


      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _medium, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null){
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_240x240_crop_center$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      
      var productBYOK = false,
          productFreeGift = false,
          productBYOKorFreeGift = false,
          productSubscription = false;
      
      if (cartItem.properties !== null) {
        $.each(cartItem.properties, function(key, value) {
          if (key.charAt(0) === '_' || !value) {
            delete cartItem.properties[key];
          }
          if (key === 'Product from' && value === 'BYOK page') {
            productBYOK = true;
          }
          if (key === 'Free' && value === 'Gift') {
            productFreeGift = true;
          }
          if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
            productSubscription = true;
            cartSubscription = true;
          }
        });
      }
      if ((productSubscription == false) && (productFreeGift == false)) {
        foundAllSubscription = false;
      }
      //productBYOK = $('body').hasClass('template-gamification-b') == false ? productBYOK : false;
      productBYOK = false;
      productBYOKorFreeGift = productBYOK || productFreeGift;
            
      var product_title = cartItem.product_title;
      var final_line_price = cartItem.final_line_price;
      var price = 0;
      var url = cartItem.url;
      if ( productSubscription == true ) {
        var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
        if (Object.keys(productsSubscritionJson).length > 0) {
          var result = ``;
          for (var productSubscritionJson in productsSubscritionJson) {
            // obj.hasOwnProperty() is used to filter out properties from the object's prototype chain
            if (productsSubscritionJson.hasOwnProperty(productSubscritionJson)) {
              if (productsSubscritionJson[productSubscritionJson]['subscriptionProductId'] == cartItem.variant_id) {
                url = productsSubscritionJson[productSubscritionJson]['url'];
                price = productsSubscritionJson[productSubscritionJson]['price'] * cartItem.quantity;
              }
            }
          }
        }
      }
      if (price != 0) {
        cartBYOKLinesWithOutDiscount = cartBYOKLinesWithOutDiscount + price;
      } else {
        cartBYOKLinesWithOutDiscount = cartBYOKLinesWithOutDiscount + final_line_price;
      }
      product_title = 0 < product_title.indexOf("-") ? product_title.split("-")[0] : product_title;
      /*if($('body').hasClass('template-gamification-a') == true) {
        if (cartBYOK == true && cartBYOKDiscount != false && productBYOK == true && productSubscription == true) {
          //if (cartItem.product_title.indexOf('Off Auto renew') > -1) {
          if (cartItem.product_title.indexOf('Auto renew') > -1) {
            let discountReplace = '15';
            if (cartBYOKDiscount.indexOf('Q2P0MK5CWPC5') > -1) { // Cupon for discount 20%
              discountReplace = '20';
              final_line_price = final_line_price - (final_line_price * 5.84 / 100);
            }
            if (cartItem.product_title.indexOf('Auto renew') > -1 && product_title.indexOf('Auto renew') == -1) {
              product_title = product_title + ' Auto renew';
            }
          } else {
            product_title = product_title + ' Auto renew';
          }
        } else if ( product_title.indexOf("Auto renew") == -1 && cartItem.product_title.indexOf("Auto renew") > -1 ) {
          //product_title = product_title + ' 15.00% Off Auto renew';
          product_title = product_title + ' Auto renew';
        } else if (cartBYOK == true && cartBYOKDiscount != false && productBYOK == true) {
          if (cartBYOKDiscount.indexOf('10T5DXA4WVRC') > -1) { // Cupon for discount 5%
            final_line_price = final_line_price - (final_line_price * 5 / 100);
          }
          if (cartBYOKDiscount.indexOf('RKWPP9KZ4RMP') > -1) { // Cupon for discount 10%
            final_line_price = final_line_price - (final_line_price * 10 / 100);
          }
        }
      } else if($('body').hasClass('template-gamification-b') == true) {*/
        if (cartBYOK == true && cartBYOKDiscount != false && productSubscription == true) {
          //if (cartItem.product_title.indexOf('Off Auto renew') > -1) {
          if (cartItem.product_title.indexOf('Auto renew') > -1 && cartItem.product_title.indexOf('Shark Tank') < 0) {
            let discountReplace = '15';
            if (cartBYOKDiscount.indexOf('2077J038XQDE') > -1) { // Cupon for discount 20%
              discountReplace = '20';
              final_line_price = final_line_price - (final_line_price * 5.84 / 100);
            }
            if (cartItem.product_title.indexOf('Auto renew') > -1 && product_title.indexOf('Auto renew') == -1) {
              product_title = product_title + ' Auto renew';
            }
          } else {
            product_title = product_title + ' Auto renew';
          }
        } else if ( product_title.indexOf("Auto renew") == -1 && cartItem.product_title.indexOf("Auto renew") > -1 ) {
          //product_title = product_title + ' 15.00% Off Auto renew';
          product_title = product_title + ' Auto renew';
        } else if (cartBYOK == true && cartBYOKDiscount != false) {
          if (cartBYOKDiscount.indexOf('5PMAD5PDJTH3') > -1) { // Cupon for discount 5%
            final_line_price = final_line_price - (final_line_price * 5 / 100);
          }
          if (cartBYOKDiscount.indexOf('10XTH7YZNWPX') > -1) { // Cupon for discount 10%
            final_line_price = final_line_price - (final_line_price * 10 / 100);
          }
        }
      //}
      cartBYOKLinesDiscount = cartBYOKLinesDiscount + final_line_price;
      
      if ( productSubscription == true ) {
        cartLinesDiscount15 = cartLinesDiscount15 + final_line_price;
      } else {
        cartLinesDiscount15 = cartLinesDiscount15 + cartItem.final_line_price - (cartItem.final_line_price * 0.15);
      }

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: url,
        img: prodImg,
        //name: product_title,
        name: 0 < product_title.indexOf("-") ? product_title.split("-")[0] : product_title,
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        originalPrice: Shopify.formatMoney(cartItem.original_price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(final_line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),

        lineDiscount: cartItem.line_level_discount_allocations.length,
        lineDiscounts: cartItem.line_level_discount_allocations.map((obj) => Object.keys(obj).reduce((acc, key) => {
                      if (key === "amount") {
                        acc[key] = Shopify.formatMoney(obj[key], settings.moneyFormat);
                      } else {
                        acc[key] = obj[key];
                      }
                      return acc;
                    }, {})),
        lineDiscountedPrice: Shopify.formatMoney(cartItem.final_line_price, settings.moneyFormat),

        discounts: cartItem.discounts,
        discountPrice: Shopify.formatMoney(cartItem.original_price - cartItem.discounted_price, settings.moneyFormat),
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        discountedPrice: Shopify.formatMoney(cartItem.discounted_price, settings.moneyFormat),
        
        productBYOK: productBYOK,
        productFreeGift: productFreeGift,
        productBYOKorFreeGift: productBYOKorFreeGift,
        productSubscription: productSubscription
      };

      items.push(item);
    });

    var productSuggestion = {};
    var productSuggestionFound = false;
    if (typeof searchSuggestion === "function") {
      productSuggestion = searchSuggestion(cart);
      if(Object.keys(productSuggestion).length > 0) {
        productSuggestionFound = true;
      }
      //console.log('productSuggestion',productSuggestion);
    }
  
    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      //totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cartBYOKLinesDiscount, settings.moneyFormat),

      cartDiscount: cart.cart_level_discount_applications.length,
      cartDiscounts: cart.cart_level_discount_applications.map((obj) => Object.keys(obj).reduce((acc, key) => {
                      if (key === "total_allocated_amount") {
                        acc[key] = Shopify.formatMoney(obj[key], settings.moneyFormat);
                      } else {
                        acc[key] = obj[key];
                      }
                      return acc;
                    }, {})),

      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      
      cartBYOK: cartBYOK,
      cartBYOKDiscount: cartBYOKDiscount,
      foundAllSubscription: foundAllSubscription,
      cartSubscription: cartSubscription,
      isFreeShipping: cart.total_price >= theme.ajaxCartSettings.subscribeFree ? true : false,
      subscribeText: cart.total_price >= theme.ajaxCartSettings.subscribeFree ? theme.ajaxCartSettings.subscribeTextFree : theme.ajaxCartSettings.subscribeText,
      productSuggestion: productSuggestion,
      productSuggestionFound: productSuggestionFound,
      isCartBYOKLinesWithOutDiscount: cartBYOKLinesWithOutDiscount == cartBYOKLinesDiscount ? false : true,
      cartBYOKLinesWithOutDiscount: Shopify.formatMoney(cartBYOKLinesWithOutDiscount, settings.moneyFormat)
    }
                               
    $cartContainer.append(template(data));

    if ($cartContainer.find('.build-your-kit.wrapper').length && buildYourKit != null) {
      buildYourKit = $cartContainer.find('.build-your-kit.wrapper').replaceWith(buildYourKit);
    }
    
    if (cartLinesDiscount15 >= theme.ajaxCartSettings.subscribeFree) {
      $('.ajaxcart__subs .ajaxcart__form-subs-text').html(theme.ajaxCartSettings.subscribeTextFree);
    } else {
      $('.ajaxcart__subs .ajaxcart__form-subs-text').html(theme.ajaxCartSettings.subscribeText);
    }
    if($('body').hasClass('template-gamification-b') == true) {
      if (cartBYOKDiscount != false) {
        if ((cartBYOKDiscount.indexOf('2077J038XQDE') > -1) || (cartBYOKDiscount.indexOf('10XTH7YZNWPX') > -1)) {
          $('.ajaxcart__subs .ajaxcart__form-subs-text').html($('.ajaxcart__subs .ajaxcart__form-subs-text').html().replace('15%', '20%'));
        }
      }
    }
    
    if (cart.total_price >= theme.ajaxCartSettings.subscribeFree) {
      $('.ajaxcart__button .ajaxcart__button-bottom').html(theme.ajaxCartSettings.dayGuaranteeTextFree);
    } else {
      $('.ajaxcart__button .ajaxcart__button-bottom').html(theme.ajaxCartSettings.dayGuaranteeText);
    }
    
    if (typeof searchSuggestion === "function") {
      $('.productSuggestion-title').text(theme.productSuggestionStrings.header);
      $('.ajaxcart__addSuggestion').text(theme.productSuggestionStrings.buttonLabel);
    }

    submitAjaxCart(cartSubscription);
    
    cartCallback(cart, doneFreeGiftProduct, doneRulesDiscount);
  };

  cartCallback = function(cart, doneFreeGiftProduct, doneRulesDiscount) {
    if(doneFreeGiftProduct === undefined) {
      doneFreeGiftProduct = false;
    }
    if(doneRulesDiscount === undefined) {
      doneRulesDiscount = false;
    }
    //if($('body').hasClass('template-gamification-b') == true) {
      if(typeof Shopify.gamification.dRUpdateBYOB == 'function') {
        cart = Shopify.gamification.dRUpdateBYOB(cart, true, doneFreeGiftProduct, doneRulesDiscount);
      }
    //}

    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
    
    sizeCartDrawerFooter();
  };
  
  function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }
    
  submitAjaxCart = function(cartSubscription) {
    function goToCheckout(cartSubscription,cart) {
      //console.log(cartSubscription);
      /*-- Mixpanel Code --*/
      document.getElementById("mixpanel_id").value = mixpanel.get_distinct_id();
      mixpanel.init("1a682e212c332eea79a569a7d459c386");
      mixpanel.track("Initiate Check out");
      /*-- End of Mixpanel Code --*/
      if (cartSubscription) {
        var l = "",
            s = "&cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2],
            u = "myshopify_domain=".concat(Shopify.shop);
        //window.SLIDECART_CUSTOMER_ID && window.SLIDECART_CUSTOMER_EMAIL && (l = "&customer_id=".concat(window.SLIDECART_CUSTOMER_ID, "&customer_email=").concat(window.SLIDECART_CUSTOMER_EMAIL));
        try {
          var c = "&" + ga.getAll()[0].get("linkerParam");
        } catch (e) {
          c = ""
        }
        var codeCookieValue = getCookie('discount_code');
        var rechargeCookieValue = getCookie('ec-recharge-discount');
        if(codeCookieValue && !rechargeCookieValue){
          l = l.concat("&discount=" + codeCookieValue);
        } else {
          l = l.concat("&discount=" + rechargeCookieValue);
        }
        var f = "https://checkout.rechargeapps.com/r/checkout?" + u + s + c + l;
        console.log('go to rechage checkout');
        window.location = f;
        return false;
      } else {
        console.log('go to shopify checkout');
        //window.location = "/checkout";
        let location_url = '/checkout';
        let discount = '';
        if(cart['attributes'] != undefined) {
          //console.log(1,cart['attributes']['Discount code']);
          if(cart['attributes']['Discount code'] != undefined) {
            //console.log(2,cart['attributes']['Discount code']);
            discount = cart['attributes']['Discount code'];
          }
        }
        if (discount != '') {
          location_url = "/discount/" + discount + "?redirect=/checkout";
        }
        //console.log(5,location_url);
        //console.log(6,cart['attributes']);
        window.location = location_url;
        return false;
      }
    }
    $('.cart.ajaxcart__form.ajaxcart [type="submit"]').click(function(e){
      console.log('submit');
      e.preventDefault();
      if (isUpdating == false) {
        var result = true;
        $.ajax({
          type: 'GET',
          url: '/cart.json',
          async: false,
          dataType: 'json',
          success: function (cart) {
            var isResult = null;
            /*if($('body').hasClass('template-gamification-a') == true) {
              if(typeof freeGiftProduct == 'function') {
                isResult = freeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
                console.log('submitAjaxCart-result',isResult);
                if (isResult.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
                  result = false;
                }
              }
            } else if($('body').hasClass('template-gamification-b') == true) {*/
              if(typeof dRFreeGiftProduct == 'function') {
                isResult = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
                if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
                  result = false;
                }
              }
            //}

            if (result == false) {
              $('.cart.ajaxcart__form.ajaxcart [type="submit"]').addClass('disabled').attr("disabled", "disabled");
              $('.cart.ajaxcart__form.ajaxcart').addClass('disabled').attr("disabled", "disabled");
              return false;
            } else {
              if (isResult.cart.item_count > 0) {
                var isAllOneTime = true;
                var isBYOB = false;
                $.each(isResult.cart.items, function(index, cartItem) {
                  if (cartItem['properties'] != null) {
                    //console.log(cartItem['properties']);
                    if (cartItem['properties']['subscription_id'] != null) {
                      isAllOneTime = false;//console.log(cartItem['properties']['subscription_id']);
                    }
                    //console.log(cartItem['properties']['Product from']);
                    if (cartItem['properties']['Product from'] != null) {
                      if (cartItem['properties']['Product from'] == "BYOK page") {
                        isBYOB = true;
                      }
                    }
                  }
                });
                console.log('isAllOneTime',isAllOneTime,'isBYOB',isBYOB);
                if (isAllOneTime == true && isBYOB == false) {
                  console.log('Sorry, you have added non-subscription products, you cannot add subscription products, if you want to add this product, the non-subscription products will be removed.');
                  let textSwal = 'Subscribe to save 15% & get Free Shipping?';
                  if($('body').hasClass('template-gamification-b') == true) {
                    if (cart.attributes != undefined) {
                      if (cart.attributes["Discount code"] && cart.attributes["Discount code"] != 'False' ) {
                        if (cart.attributes["Discount code"].indexOf('10XTH7YZNWPX') > -1) {
                          textSwal = textSwal.replace('15%', '20%');
                        }
                      }
                    }
                  }
                  Swal.fire({
                    title: 'You can save today',
                    text: textSwal,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    confirmButtonClass: 'btn',
                    cancelButtonText: 'No',
                    cancelButtonClass: 'btn',
                    customClass: {
                      container: 'swalBYOB swalBYOBPopups'
                    }
                  }).then((result) => {
                    if (result.isConfirmed) {
                      $('.cart__checkout').removeAttr('disabled').removeClass('disabled');
                      $('#ajaxcart__form-subs').trigger('click');
                      e.preventDefault();
                      return false;
                    } else {
                      goToCheckout(cartSubscription,isResult.cart);
                    }
                  });
                } else {
                  goToCheckout(cartSubscription,isResult.cart);
                }
              } else {
                goToCheckout(cartSubscription,isResult.cart);
              }
            }
            
          }
        });
      } else {
        e.preventDefault();
        return false;
      }
    });
  };
    
  sizeCartDrawerFooter = function() {
    // Elements are reprinted regularly so selectors are not cached
    var $cartFooter = $('.ajaxcart__footer').removeAttr('style');
    var $cartButton = $('.ajaxcart__button').removeAttr('style');
    var $cartInner = $('.ajaxcart__inner').removeAttr('style');
    var $cartDrawerInner = $('#CartContainer').removeAttr('style');
    if($cartFooter.length != 0 && $cartButton.length != 0 && $cartInner.length != 0) {
      var cartFooterHeight = $cartFooter.outerHeight();
      var cartButtonHeight = $cartButton.outerHeight();
      var cartDrawerTitleHeight = $('.ajaxcart__head').outerHeight();
      var cartDrawerInnerHeight = $cartDrawerInner.outerHeight();
      $cartDrawerInner.css('height', cartDrawerInnerHeight - cartDrawerTitleHeight);

      $cartInner.css('bottom', cartFooterHeight + cartButtonHeight);
      $cartFooter.css('bottom', cartButtonHeight);
    } else {
      $cartDrawerInner.css('height', 0);
    }
    
    // Select the node that will be observed for mutations
    const targetNode = document.getElementsByClassName('ajaxcart__button dcodeapp');
    if( targetNode.length > 0 ) {
      // Options for the observer (which mutations to observe)
      const config = { attributes: true, childList: true, subtree: true };
      // Callback function to execute when mutations are observed
      const callback = function(mutationsList, observer) {
        /*for(let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            console.log('A child node has been added or removed.');
          }
          else if (mutation.type === 'attributes') {
            console.log('The ' + mutation.attributeName + ' attribute was modified.');
          }
        }*/
        sizeCartDrawerFooter();

        // Later, you can stop observing
        observer.disconnect();
      };
      // Create an observer instance linked to the callback function
      const observer = new MutationObserver(callback);
      // Start observing the target node for configured mutations
      observer.observe(targetNode[0], config);
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.off('click', '.ajaxcart__qty-adjust').on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // remove from the ajaxcart
    $body.off('click', '.ajaxcart__remove').on('click', '.ajaxcart__remove', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line');

      var qty = 0;

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Update quantity based on input on change
    $body.off('change', '.ajaxcart__qty-num').on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.off('submit', 'form.ajaxcart').on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.off('focus', '.ajaxcart__qty-adjust').on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      isUpdating = true;
      $body.addClass('drawer--is-loading');

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.off('change', 'textarea[name="note"]').on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function(cart) {});
    });

    // Check subscribe
    $body.off('change', '.ajaxcart__form-subs').on('change', '.ajaxcart__form-subs', function() {
      if (isUpdating) {
        return;
      }
      console.log('change',$(this).is(':checked'));
      if ($(this).is(':checked') == false) {
        /*if($('body').hasClass('template-gamification-b') == false) {
          ShopifyAPI.getCart(changeProductsToOnTime);
        } else {*/
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToOneTime,true);
        //}
      } else {
        /*if($('body').hasClass('template-gamification-b') == false) {
          ShopifyAPI.getCart(changeProductsToSubs);
        } else {*/
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToSubs,true);
        //}
      }
    });

    $body.off('change', '.ajaxcart__form-subs_select__frequency').on('change', '.ajaxcart__form-subs_select__frequency', function() {
      if (isUpdating) {
        return;
      }
      if ($('#ajaxcart__form-subs').val() == false) {
        /*if($('body').hasClass('template-gamification-b') == false) {
          ShopifyAPI.getCart(changeProductsToOnTime);
        } else {*/
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToOneTime);
        //}
      } else {
        /*if($('body').hasClass('template-gamification-b') == false) {
          ShopifyAPI.getCart(changeProductsToSubs);
        } else {*/
          ShopifyAPI.getCart(Shopify.gamification.dRChangeProductsToSubs);
        //}
      }
    });

    function changeProductsToSubs(cart) {
      
      // Show empty cart
      if (cart.item_count === 0) {
        $(settings.emptySelector).show();
        $(settings.triggerSelector).removeClass('js-cart-full');
        cartCallback(cart);
        return;
      }
      
      isUpdating = true;
      $body.addClass('drawer--is-loading');
      
      var itemsToAdd = [];
      var items = new Object();
      var quantityItems = 0;
      
      var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
      if (Object.keys(productsSubscritionJson).length == 0) {
        return;
      }
      
      // Add each item to our handlebars.js data
      $.each(cart.items, function(index, cartItem) {
        var productSubscription = false,
            productSubscriptionId = '',
            productShippingIntervalFrequency = '',
            productShippingIntervalUnitType = '',
            productFreeGift = false;

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
              productSubscription = true;
            }
            if (key === 'subscription_id') {
              productSubscriptionId = value;
            }
            if (key === 'shipping_interval_frequency') {
              productShippingIntervalFrequency = value;
            }
            if (key === 'shipping_interval_unit_type') {
              productShippingIntervalUnitType = value;
            }
            if (key === 'Free' && value === 'Gift') {
              productFreeGift = true;
            }
          });
        }
        
        if (productSubscription == false) {
          if (productsSubscritionJson[cartItem.product_id] != undefined) {
            if (productsSubscritionJson[cartItem.product_id]['subscriptionProductId'] != undefined) {
              if (productsSubscritionJson[cartItem.product_id]['subscriptionProductId'] != false) {
                var id = '';
                var quantity = 0;
                var subscription_id = $(this).attr('data-subscription-id');
                var properties = {};
                id = productsSubscritionJson[cartItem.product_id]['subscriptionProductId'];
                quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
                properties = {};
                if (cartItem['properties'] != null) {
                  properties = cartItem['properties'];
                }
                properties["AB Gamification"] = 'A';
                properties["shipping_interval_frequency"] = $('#ajaxcart__form-subs_shipping_interval_frequency').val();
                properties["shipping_interval_unit_type"] = 'Weeks';
                properties["subscription_id"] = productsSubscritionJson[cartItem.product_id]['subscriptionId'];
                items[id] = {
                  id: id, 
                  quantity: quantity, 
                  properties: properties
                };
                quantityItems += quantity;
              }
            }
          }
        } else {
          var id = '';
          var quantity = 0;
          var properties = {};
          id = cartItem.id;
          quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
          properties = {};
          if (cartItem['properties'] != null) {
            properties = cartItem['properties'];
          }
          properties["AB Gamification"] = 'A';
          properties["shipping_interval_frequency"] = $('#ajaxcart__form-subs_shipping_interval_frequency').val();
          properties["shipping_interval_unit_type"] = 'Weeks';
          properties["subscription_id"] = productSubscriptionId;
          items[id] = {
            id: id, 
            quantity: quantity, 
            properties: properties
          };
        }
      });
      
      //console.log(items);
      
      itemsToAdd.push(
        {
          items: items
        }
      );
      //console.log(itemsToAdd);
      
      var item = itemsToAdd.pop();
      //console.log(item);
      
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        async: false,
        dataType: "json",
        success: function(t) {
          $.ajax({
            url: '/cart/add',
            dataType: 'json',
            type: 'post',
            data: item,
            success: function(t) {
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: 'attributes[Product Type]=Subscription',
                dataType: 'json',
                success: function(cart) {
                  isUpdating = false;
                  cartUpdateCallback(cart);
                }
              });
            },
            error: itemErrorCallback
          });
        }
      });
    }
    
    function changeProductsToOnTime(cart) {
      
      // Show empty cart
      if (cart.item_count === 0) {
        $(settings.emptySelector).show();
        $(settings.triggerSelector).removeClass('js-cart-full');
        cartCallback(cart);
        return;
      }
      
      isUpdating = true;
      $body.addClass('drawer--is-loading');
      
      var itemsToAdd = [];
      var items = new Object();
      var quantityItems = 0;
      
      var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
      if (Object.keys(productsSubscritionJson).length == 0) {
        return;
      }
      
      // Add each item to our handlebars.js data
      $.each(cart.items, function(index, cartItem) {
        var productSubscription = false,
            productSubscriptionId = '',
            productShippingIntervalFrequency = '',
            productShippingIntervalUnitType = '',
            productFreeGift = false;

        if (cartItem.properties !== null) {
          $.each(cartItem.properties, function(key, value) {
            if (key === 'subscription_id' || key === 'shipping_interval_frequency' || key === 'shipping_interval_unit_type') {
              productSubscription = true;
            }
            if (key === 'subscription_id') {
              productSubscriptionId = value;
            }
            if (key === 'shipping_interval_frequency') {
              productShippingIntervalFrequency = value;
            }
            if (key === 'shipping_interval_unit_type') {
              productShippingIntervalUnitType = value;
            }
            if (key === 'Free' && value === 'Gift') {
              productFreeGift = true;
            }
          });
        }
        
        
        if (productSubscription == false) {
          var id = '';
          var quantity = 0;
          id = cartItem.id;
          quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
          if (productFreeGift == false) {
            items[id] = {
              id: id, 
              quantity: quantity
            };
          } else {
            var properties = {};
            if (cartItem['properties'] != null) {
              properties["Free"] = 'Gift';
            }
            properties["AB Gamification"] = 'A';
            items[id] = {
              id: id, 
              quantity: quantity, 
              properties: properties
            };
          }
        } else {
          var id = '';
          var quantity = 0;
          for (var productSubscritionJson in productsSubscritionJson) {
            // obj.hasOwnProperty() is used to filter out properties from the object's prototype chain
            if (productsSubscritionJson.hasOwnProperty(productSubscritionJson)) {
              //console.log(productsSubscritionJson[productSubscritionJson]['subscriptionProductId'],cartItem.variant_id);
              if (productsSubscritionJson[productSubscritionJson]['subscriptionProductId'] == cartItem.variant_id) {
                id = productsSubscritionJson[productSubscritionJson]['variantId'];
                break;
              }
            }
          }
          if(id != '') {
            quantity = items[id] != undefined ? items[id].quantity + cartItem.quantity : cartItem.quantity;
            var properties = {};
            properties["AB Gamification"] = 'A';
            items[id] = {
              id: id, 
              quantity: quantity, 
              properties: properties
            };
          }
        }
      });
      
      //console.log(items);
      
      itemsToAdd.push(
        {
          items: items
        }
      );
      //console.log(itemsToAdd);
      
      var item = itemsToAdd.pop();
      //console.log(item);
      
      $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        async: false,
        dataType: "json",
        success: function(t) {
          $.ajax({
            url: '/cart/add',
            dataType: 'json',
            type: 'post',
            data: item,
            success: function(t) {
              $.ajax({
                type: 'POST',
                url: '/cart/update.js',
                data: 'attributes[Product Type]=One Time',
                dataType: 'json',
                success: function(cart) {
                  isUpdating = false;
                  cartUpdateCallback(cart);
                }
              });
            },
            error: itemErrorCallback
          });
        }
      });
    }
    
    if (typeof searchSuggestion === "function") {
      $body.off('click', '.ajaxcart__addSuggestion').on('click', '.ajaxcart__addSuggestion', function() {
        if (isUpdating) {
          return;
        }

        isUpdating = true;
        $body.addClass('drawer--is-loading');

        //var data = '';
        var itemsToAdd = [];
        var items = new Object();
        if ($('.ajaxcart__form-subs').is(':checked') == false) {
          //data = "quantity=1&id=" + $(this).data('id');
          items[$(this).data('id')] = {
            id: $(this).data('id'), 
            quantity: 1
          };
        } else {
          var properties = {};
          properties = {};
          properties["shipping_interval_frequency"] = $('#ajaxcart__form-subs_shipping_interval_frequency').val();
          properties["shipping_interval_unit_type"] = 'Weeks';
          properties["subscription_id"] = $(this).data('subscription-id');
          items[$(this).data('subscription-product-id')] = {
            id: $(this).data('subscription-product-id'), 
            quantity: 1, 
            properties: properties
          };
        }
        
        itemsToAdd.push(
          {
            items: items
          }
        );

        var item = itemsToAdd.pop();
        
        $.ajax({
          url: '/cart/add',
          dataType: 'json',
          type: 'post',
          data: item,
          success: function(product) {
            isUpdating = false;
            //itemAddedCallback(product);
            ShopifyAPI.getCart(adjustCartCallback);
          },
          error: itemErrorCallback
        });
      });
    }
  };

  adjustCartCallback = function (cart) {
    let doneFreeGiftProduct = false,
        doneRulesDiscount = false;
    /*if($('body').hasClass('template-gamification-a') == true) {
      if(typeof freeGiftProduct == 'function' && doneFreeGiftProduct == false) {
        var result = freeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        console.log(result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      }
    } else if($('body').hasClass('template-gamification-b') == true) {*/
      if(typeof dRFreeGiftProduct == 'function' && doneFreeGiftProduct == false) {
        var result = dRFreeGiftProduct(cart, $('body').hasClass('template-cart') ? true : false, true);
        console.log(result);
        if (result.foundMoreFreeGift == true && $('body').hasClass('template-cart') == true) {
          ShopifyAPI.getCart(cartUpdateCallback);
          return false;
        } else {
          cart = result.cart;
          doneFreeGiftProduct = true;
        }
      } else {
        if(typeof dRRulesDiscount == 'function') {
          var cartSubscription = false;
          if (cart['attributes']['Product Type'] == 'Subscription') {
            var cartSubscription = true;
          }
          var productPouches = 0;
          var total_price = 0;
          var totalPouches = 0;
          $.each(cart.items, function(index, cartItem) {
            var price = cartItem.price * cartItem.quantity;
            var productsSubscritionJson = JSON.parse($('#productsSubscritionJson').html());
            if (Object.keys(productsSubscritionJson).length > 0) {
              if(cartSubscription == true) {
                //console.log(price);
                for (x in productsSubscritionJson) {
                  //console.log(productsSubscritionJson[x]);
                  if (productsSubscritionJson[x]["subscriptionProductId"] != undefined) {
                    //console.log(productsSubscritionJson[x]["subscriptionProductId"],variant_id);
                    if (productsSubscritionJson[x]["subscriptionProductId"] == cartItem.variant_id) {
                      productPouches = productsSubscritionJson[x]['pouches'];
                      price = productsSubscritionJson[x]["price"] * cartItem.quantity;
                      break;
                    }
                  }
                }
                //console.log(price);
              } else {
                if (productsSubscritionJson[cartItem.product_id] != undefined) {
                  productPouches = productsSubscritionJson[cartItem.product_id]['pouches'];
                }
              }
            }
            total_price += price;
            totalPouches += productPouches*cartItem.quantity;
          });
          dRRulesDiscount(totalPouches,cartSubscription);
          doneRulesDiscount = true;
        }
      }
    //}
    // Update quantity and price
    updateCountPrice(cart);

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart, doneFreeGiftProduct, doneRulesDiscount);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#AjaxQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]:not(.rc_variant_quantity)');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            sourceSingles = $("#JsQtySingles").html(),
            sourcePacks = $("#JsQtyPacks").html(),
            template = Handlebars.compile(source),
            templateSingles = Handlebars.compile(sourceSingles),
            templatePacks = Handlebars.compile(sourcePacks),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId,
              pdp: $el.closest('.product-type__singles_pdp').length > 0 ? true : false
            };

        // Append new quantity selector then remove original
        if ($el.closest('.product-type__singles').length > 0) {
          $el.after(templateSingles(data)).remove();
        } else if ($el.closest('.product-type__pack').length > 0) {
          $el.after(templatePacks(data)).remove();
        } else {
          $el.after(template(data)).remove();
        }
      });

      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').off('click').on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.js-qty__num:not(.js-qty__num-div)'),
            $qtySelectorTextBox = $el.siblings('.text-box').find('.js-qty__num:not(.js-qty__num-div)'),
            $qtySelectorSpan = $el.siblings('.js-qty__num-div'),
            qty = parseInt($qtySelector.length > 0 ? $qtySelector.val().replace(/\D/g, '') : $qtySelectorTextBox.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }
        
        if ($el.closest('.js-product-form, .addtocart-form').length > 0) {
          if (qty > 18) qty = 18;
        }

        // Update the input's number
        if ($qtySelector.length > 0) {
          $qtySelector.val(qty);
        } else {
          $qtySelectorTextBox.val(qty);
        }
        
        if ($qtySelectorSpan.length > 0) {
          $qtySelectorSpan.find('span').removeClass('active');
          $qtySelectorSpan.find('[data-value=' + qty + ']').addClass('active');
        }
      });
      
      // Update quantity based on input on change
      $('.js-qty__num:not(.js-qty__num-div)').off('change').on('change', function() {

        var $el = $(this),
            qty = parseInt($el.val().replace(/\D/g, ''));

        var qty = validateQty(qty);

        if ($el.closest('.js-product-form, .addtocart-form').length > 0) {
          if (qty > 18) qty = 18;
        }
        
        $el.val(qty);
      });
      
      // Update quantity based on input on change
      $('.js-qty__num-div:not(.active)').off('click').on('click', function() {

        var $el = $(this),
            $qtySelector = $el.siblings('.js-qty__num:not(.js-qty__num-div)');

        if ($el.hasClass('open') == false) {
          $el.toggleClass('active');

          if ($el.hasClass('active') && $el.closest('.product-top').length > 0) {
            var $parent = $el.closest('.product-top');
            $parent.children('.js-qty__num-div_copy').remove();
            var $qtySelectorDivCopy = $el.clone().addClass('js-qty__num-div_copy').addClass('data-' + $qtySelector.val());
            $parent.after( $qtySelectorDivCopy );
            
            $('.js-qty__num-div_copy.active span').off('click').on('click', function() {

              var $el = $(this),
                  $qtySelectorDivCopy = $el.closest('.js-qty__num-div_copy'),
                  $parent = $el.closest('.product--natural'),
                  $qtySelector = $parent.find('.js-qty .js-qty__num:not(.js-qty__num-div)'),
                  $qtySelectorDiv = $parent.find('.js-qty .js-qty__num-div');

              var qty = $el.attr('data-value');

              $qtySelector.val(qty);

              $qtySelectorDiv.removeClass('active open').find('span').removeClass('active');
              $qtySelectorDiv.find('[data-value=' + qty + ']').addClass('active');

              $qtySelectorDivCopy.remove();

              //console.log(qty);
            });
          } else if ($el.hasClass('active')) {
            $el.addClass('data-' + $qtySelector.val());
            $('.js-qty__num-div.active span').off('click').on('click', function() {

              var $el = $(this),
                  $qtySelectorDiv = $el.closest('.js-qty__num-div'),
                  $qtySelector = $qtySelectorDiv.siblings('.js-qty__num:not(.js-qty__num-div)');

              var qty = $el.attr('data-value');

              $qtySelector.val(qty);

              $qtySelectorDiv.removeClass('active').removeClass (function (index, css) {
                return (css.match (/(^|\s)data-\S+/g) || []).join(' ');
              });
              $qtySelectorDiv.find('span').removeClass('active');
              $qtySelectorDiv.find('[data-value=' + qty + ']').addClass('active');


              //console.log(qty);
              //console.log($qtySelectorDiv.find('[data-value=' + qty + ']'));
              
              $('.js-qty__num-div.active span').off('click');
            });
          }
          
          $el.addClass('open');
        } else {
          $el.removeClass('open');
        }
      });
            
      $('body').off('click.onBodyClick').on('click.onBodyClick', function(event) {
        var $target = $(event.target),
            $targetSelector = $('.js-qty__num-div_copy.active');
        //console.log($targetSelector);
        //console.log($target);
        //console.log($target.parents('.js-qty__num-div.active').length);
        if (
          $target !== $targetSelector &&
          !$target.parents('.js-qty__num-div.active').length
        ) {
          $('.js-qty__num-div.active').removeClass('active open');
          $('.js-qty__num-div_copy').remove();
        }
        
        $('.js-qty__num-div.active').each(function() {
          //console.log($(this));
          //console.log($target.parents('.js-qty__num-div.active'));
          if (!$(this).is($target.parents('.js-qty__num-div.active'))) {
            $(this).removeClass('active open');
            //console.log('entro1');
          }
        });
        $('.js-qty__num-div_copy').each(function() {
          //let $this = $(this);
          //let $targetDivCopy = $target.parents('.product--natural').find('.js-qty__num-div_copy');
          //console.log($this);
          //console.log($targetDivCopy);
          if (!$(this).is($target.parents('.product--natural').find('.js-qty__num-div_copy'))) {
            $(this).remove();
            //console.log('entro2');
          }
        });
      });
    }
  };

  validateQty = function (qty) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    loadWithOutGetCart: loadCartWithOutGetCart,
    loadWithOut: loadWithOutCart
  };

  return module;

}(ajaxCart || {}, jQuery));
